import { request, METHOD } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/* 获取休息日设置数据列表（#291） */
export function getHolidayList() {
  return request("".concat(BASE_URL) + "/dayOff/setting/list", METHOD.GET);
}

/* 更新品牌信息数据（#182） */
export function updateHolidayfo(data) {
  return request("".concat(BASE_URL) + "/dayOff/setting", METHOD.PUT, data);
}
export default {
  getHolidayList: getHolidayList,
  updateHolidayfo: updateHolidayfo
};